import { Component, OnInit, NgZone, ElementRef, Inject, ViewChildren, AfterViewInit } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { LoginService } from '../home/login.service';
import { FormBuilder, Validators } from '@angular/forms';
import { AppComponent } from '../app.component';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { IAccount } from '../account/account';
import { ToastrService } from 'ngx-toastr';
import { ICartItems } from '../onlineorder/cartitems';
import { Subscription } from 'rxjs';
import { OrderService } from '../onlineorder/order.service';
import { CreateAccountService } from '../account/create-account.service';
import { ICustomerInfoResponse } from '../account/customerinforesponse';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'environments/environment';
import { ApiCacheService } from '../core/api-cache.service';
import { SessionService } from '../session/session.service';
@Component({
  standalone: false,
    templateUrl: './seamlessauth.component.html'
})
export class SeamlessAuthComponent implements OnInit {

    public loginInfo: any;
    private sub: Subscription;
    accounts!: IAccount[];
    errorMessage!: string;
    locale: string;
    public custName!: string;
    public cGuid: any;
    public allCustInfo: ICustomerInfoResponse;
    public caption: string;
    public transErrMsg: string;
    translatedText = '';
    constructor(private _loginService: LoginService, private router: Router,
        private zone: NgZone, private app: AppComponent, public onlineorder: OnlineOrderService,
        private createAccountService: CreateAccountService, public translate: TranslateService,
        public admin: AdminService, private spinner: NgxSpinnerService, private toaster: ToastrService,
        @Inject(ElementRef) private element: ElementRef, private _route: ActivatedRoute, private orderService: OrderService,
        private cache: ApiCacheService,  private sessionService: SessionService) {

        this.sub = this._route.params.subscribe(
            params => {
                let id = params['id'];
                // this._productService.getRepInfo(id.toString()).subscribe(rep => {
                //     this.rep = rep;
                //     this.app.rep = rep;
                // });

                this.cGuid = id;
                localStorage.setItem('guid', id.toString());

            });
        //get locale
        this.sub = this._route.queryParams.subscribe(params => {
            let lc = params['locale']?.toLowerCase() ?? 'en';

            if (lc === 'es-us') {
                lc = 'es';
            } else {
                lc = 'en';
            }

            this.locale = lc;
            this.app.locale = lc;

            localStorage.setItem('locale', lc);
        });

        if (this.locale === 'es') {
            this.translate.setDefaultLang(this.locale);
            this.useLanguage(this.locale);
        }
        else {
            this.useLanguage(this.locale);
            this.translate.setDefaultLang('en');
        }
        //this.repIdUniversal.emit(id.toString());


        //console.log(id);



    }
    googleTranslateCall(textToTrans: string, targetLang: string): string {
        let model =
        {
            "q": [textToTrans],
            "target": targetLang
        };
        this.admin.googleTranslate(model).subscribe((response: any) => {
            //console.log('Translate Call: ' + response.data.translations[0].translatedText);
            this.translatedText = response.data.translations[0].translatedText;
            return this.translatedText;
        });
        return '';
    }

    showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
        //use this for dynamic error messages
        if (staticErrorMsg === false) {
            let locale = this.getLocale();
            if (locale !== 'en') {

                //were gonna do it nested, couldn't do it as a standalone method.
                let model =
                {
                    "q": [errorMessage],
                    "target": locale
                };

                this.admin.googleTranslate(model).subscribe((response: any) => {

                    let res = response.data.translations[0].translatedText as string;
                    this.translatedText = response.data.translations[0].translatedText as string;
                    this.transErrMsg = this.translatedText;
                    localStorage.setItem('translatedText', res);


                }, error => console.log(error), () => {

                    this.translate.get(subject).subscribe((res: string) => {
                        this.caption = res;
                        console.log(res);
                    }, error => console.log(error), () => {
                        this.spinner.hide();
                        //once the caption is translated, fire off the toaster popup
                        this.toaster.error(this.transErrMsg, this.caption, {
                            timeOut: 5000
                        });
                        localStorage.removeItem('translatedText');

                    });
                });



                //this.transErrMsg =  this.translatedText;
            }
            else {
                this.translate.get(subject).subscribe((res: string) => {
                    this.caption = res;
                    console.log(res);
                }, error => console.log(error), () => {
                    this.transErrMsg = errorMessage;
                    this.spinner.hide();
                    //once the caption is translated, fire off the toaster popup
                    this.toaster.error(this.transErrMsg, this.caption, {
                        timeOut: 5000
                    });
                    localStorage.removeItem('translatedText');
                });
            }
        }
        else {
            // translate the error message - not dynamic
            this.translate.get(errorMessage).subscribe((res: string) => {
                this.transErrMsg = res;
                console.log(res);
            });

            // translate the caption
            this.translate.get(subject).subscribe((res: string) => {
                this.caption = res;
                console.log(res);
            });
            this.spinner.hide();
            //show the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {

                timeOut: 5000
            });
        }
    }
    useLanguage(language: string): void {
        this.translate.use(language);
        //this.translate.currentLang = language;
        localStorage.setItem('locale', language.toString());
    }

    getLocale(): any {
        var currentLocale = localStorage.getItem('locale');
        return currentLocale;
    }
    repId(): any {
        var currentId = localStorage.getItem('repId');
        return currentId;
    }
    custGuid(): any {
        var currentGuid = localStorage.getItem('guid');
        return currentGuid;
    }
    async ngOnInit(): Promise<void> {
        this.cache.clear();
        await this.sessionService.startSession();
        this.sub = this._route.params.subscribe(
            params => {
                let id = params['id'];
                // this._productService.getRepInfo(id.toString()).subscribe(rep => {
                //     this.rep = rep;
                //     this.app.rep = rep;
                // });

                this.cGuid = id;
                localStorage.setItem('guid', id.toString());

            });
        //get locale
            this.sub = this._route.queryParams.subscribe(params => {
                let lc = params['locale']?.toLowerCase() ?? 'en';

                if (lc === 'es-us') {
                    lc = 'es';
                } else {
                    lc = 'en';
                }

                this.locale = lc;
                this.app.locale = lc;

                localStorage.setItem('locale', lc);
            });

        if (this.locale === 'es') {
            this.translate.setDefaultLang(this.locale);
            this.useLanguage(this.locale);
        }
        else {
            this.useLanguage(this.locale);
            this.translate.setDefaultLang('en');
        }

        // this._loginService.seamlessLoginVerify(this.custGuid()).subscribe(thing => this.loginInfo = thing, error => console.log(error),
        //     () => {
        //         this._loginService.getCustomerInfo().subscribe(thing => this.loginInfo = thing,
        //             error => console.log(error), () => {
        //                 this._loginService.seamlessLogin(this.custGuid()).subscribe(thing => this.loginInfo = thing, error =>
        //                     console.log(error), () => {
        //                         this.app.loggedIn = true;
        //                         if (this._loginService.loggedIn()) {
        //                             this._loginService.getCustName().subscribe(thing => this.custName = thing,
        //                             error => console.log(error), ()=> {
        //                                 this.onlineorder.latestOnlineOrder()
        //                                 .subscribe(thing2 => this.loginInfo = thing2, error => this.errorMessage = error,
        //                                 () => {
        //                                     this.onlineorder.clearOrder().subscribe(thing3 => this.accounts = thing3,
        //                                         error => this.errorMessage = error, () => {
        //                                             this.zone.run(() => {
        //                                                 setTimeout((router: Router) => {
        //                                                     this.app.myRepID = this.repId();
        //                                                     this.router.navigateByUrl('shop/from/' + this.repId());
        //                                                 }, 1000);
        //                                             });
        //                                         });
        //                                     });
        //                             })

        //                         }
        //                     })
        //                 // this.app.loggedIn = true;


        //             });


        //     });

        this._loginService.seamlessLoginVerify(this.custGuid()).subscribe(thing => this.loginInfo = thing, error => console.log(error),
            () => {
                this.spinner.show();
                this._loginService.getLbriWebApiToken().subscribe(thing => this.loginInfo = thing,
                    error => console.log(error), () => {
                        this._loginService.getCustomerInfo().subscribe(thing => this.loginInfo = thing,
                            error => console.log(error), () => {
                                this._loginService.seamlessLogin(this.custGuid()).subscribe(thing => this.loginInfo = thing, error =>
                                    console.log(error), () => {
                                        this.app.loggedIn = true;
                                        if (this._loginService.loggedIn()) {
                                            //this._loginService.getCustName().subscribe((thing: string) => this.custName = thing,
                                            //(error: any) => console.log(error), () => {
                                            this.onlineorder.latestOnlineOrder(true)
                                                .subscribe((thing2: any) => this.loginInfo = thing2, (error: string) => this.errorMessage = error,
                                                    () => {


                                                        

                                                        this.orderService.clearOrder().subscribe((thing3: IAccount[]) => this.accounts = thing3,
                                                            (error: string) => this.errorMessage = error, () => {
                                                                // update the market type here.
                                                                this.onlineorder.changeMarketType().subscribe({
                                                                    next: (res: any) => {
                                                                        console.log('cleared order, and changed market type');
                                                                    },
                                                                    complete: () => {
                                                                        var myAuth = JSON.parse(localStorage.getItem('authorizationData'));
                                                                        this.createAccountService.getCustomerInfo(myAuth.userName).subscribe({
                                                                            next: (custRes: ICustomerInfoResponse) => {
                                                                                this.allCustInfo = custRes;
                                                                                // set this to be used later.
                                                                                localStorage.setItem('allCustInfo', JSON.stringify(this.allCustInfo));
                                                                                localStorage.setItem('shippingData', JSON.stringify({
                                                                                    "first": this.allCustInfo.FirstName,
                                                                                    "last": this.allCustInfo.LastName,
                                                                                    "street1": this.allCustInfo.ShipStreet1,
                                                                                    "street2": this.allCustInfo.ShipStreet2,
                                                                                    "city": this.allCustInfo.ShipCity,
                                                                                    "state": this.allCustInfo.ShipState,
                                                                                    "zip": this.allCustInfo.ShipPostalCode,
                                                                                    "county": this.allCustInfo.ShipCounty,
                                                                                    "country": 'USA',
                                                                                    "email": this.allCustInfo.Email,
                                                                                    "phone": this.allCustInfo.Phone1

                                                                                }));
                                                                                let custName = (custRes.FirstName + ' ' + custRes.LastName).toString().replace("\"", "");
                                                                                this.custName = custName;
                                                                                localStorage.setItem('custName', custName);
                                                                                if (this.allCustInfo.PreferredCulture === 1)
                                                                                    this.app.useLanguage('en');
                                                                                else
                                                                                    this.app.useLanguage('es');
                                                                            },
                                                                            complete: () => {
                                                                                // log rocket 
                                                                                if(environment.logrocketEnabled)
                                                                                {
                                                                                    let orderInfo = JSON.parse(localStorage.getItem('orderId'));
                                                                                    this._loginService.setCurrentUser(this.allCustInfo, orderInfo.ID)
                                                                                }
                                                                                    

                                                                                this.onlineorder.calculateTax().subscribe(thing2 => thing2, error => console.log(error), () => {
                                                                                    this.spinner.hide();
                                                                                    this.zone.run(() => {
                                                                                        setTimeout((router: Router) => {
                                                                                            this.app.myRepID = this.repId();
                                                                                            this.router.navigateByUrl('shop/from/' + this.repId());
                                                                                        }, 1000);
                                                                                    });
                                                                                });
                                                                            },
                                                                            error: (err2) => {
                                                                                this.spinner.hide();
                                                                                console.log(err2);
                                                                            }
                                                                        });
                                                                    },
                                                                    error: (err1) => {
                                                                        this.spinner.hide();
                                                                        console.log(err1);
                                                                    }
                                                                })
                                                            });
                                                    });
                                            //})

                                        }
                                    })
                                // this.app.loggedIn = true;
                            });
                    });
            });
    }
}